import { Card, Group, Stack } from "@mantine/core"
import { SectionHeader } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { CustomDrawer } from "~/components/CustomDrawer"
import {
  InfoItem,
  TextValue,
} from "~/pages/Brand/Certificates/components/CertificateSummary"

import { DocumentIFrame } from "./CustomFieldProductsDetailsInfo"

interface CustomFieldDocumentDrawerProps {
  opened: boolean
  onClose: () => void
  document?: {
    id: string
    originalName: string | null
  } | null
  label: string
  cfv?: {
    value?: string
  }
}

export const CustomFieldDocumentDrawer = ({
  opened,
  onClose,
  document,
  label,
  cfv,
}: CustomFieldDocumentDrawerProps) => {
  const { t } = useTranslation()

  return (
    <CustomDrawer
      onClose={onClose}
      opened={opened}
      size="60rem"
      bg="var(--mantine-color-brand-background)"
    >
      <Group h="100%" p="xs" align="stretch">
        <Stack h="100%" flex={7} p="xs" bg="white">
          {document && <DocumentIFrame documentId={document.id} />}
        </Stack>
        <Card w="100%" h="fit-content" flex={3}>
          <Card.Section>
            <SectionHeader
              divider
              order={5}
              pb="xs"
              title={t("products:details.customFields.fieldInfo")}
            />
            <InfoItem label={label} value={<TextValue value={cfv?.value} />} />
            <InfoItem
              label="File name"
              value={<TextValue value={document?.originalName} />}
            />
          </Card.Section>
        </Card>
      </Group>
    </CustomDrawer>
  )
}
